import { Box, Divider, Grid, Typography } from "@material-ui/core";
import React, { useState } from "react";
import { addContactV2Style } from "./AddContactV2Style";
import BasicInput from "../custom/BasicInput";
import { renderEachCustomField } from "./RenderEachCustomField";
import {CustomFieldType} from "../../constants/CoreConstants";
import { useSelector } from "react-redux";
import BasicSelectWithSearch from "../custom/BasicSelectWithSearch";
import BasicFormControlWithLabelV2 from "../custom/BasicFormControlWithLabelV2";

const ContactAdditionalInfoTab = ({
  additionalInfoRef,
  customFields,
  customFieldsData,
  handleCustomFieldChange,
  setContactForm,
  contactForm,
}) => {
  const { insuranceCompanyOptions, PolicyOptions } = useSelector(
    (state) => state.addContactOptionReducer
  );
  const [selectedInsuranceCompany, setSelectedInsuranceCompany] = useState("");
  const [selectedPolicy, setSelectedPolicy] = useState("");

  const DEFAULT_CUSTOM_FIELD = {
    INSURANCE_COMPANY: "[[insurance_company]]",
    POLICY_TYPE: "[[policy_type_(l.o.b)]]",
  };
  const classes = addContactV2Style();

  const handleSelectChange = (e, data, index) => {
    const value = e.target.value;
    if (data.personalize_tag === DEFAULT_CUSTOM_FIELD.INSURANCE_COMPANY) {
      setSelectedInsuranceCompany(value);
    } else if (data.personalize_tag === DEFAULT_CUSTOM_FIELD.POLICY_TYPE) {
      setSelectedPolicy(value);
    }
    handleCustomFieldChange(value, index, data.id, data?.max_length);
  };

  return (
    <Grid container spacing={2} style={{ paddingInline: 5 }}>
      <Grid item xs={12}>
        <div
          ref={additionalInfoRef}
          data-section="Additional Info"
          style={{ width: "100%" }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                paddingRight: "10px",
              }}
            >
              <Typography variant="body2" className={classes.titleStyle}>
                Additional Info
              </Typography>
            </div>

            <div style={{ width: "100%" }}>
              <Divider />
            </div>
          </div>
        </div>
      </Grid>

      {
        customFields &&
          Array.isArray(customFields) &&
          customFields.length > 0 && (
            <div style={{ 
        width: "100%", 
        border: "1px solid #ccc",
        borderRadius: "8px",
        padding: "8px",
        margin: '8px'
        }}>
       <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          columnGap: 20,
          padding: "8px",
          width: "100%",
        }}
        className="main-add-contact-modal main-add-contact-modal-v2"
      >
        {
          customFields.map((each, index) => {
            if (
              each.type_id === CustomFieldType.SELECT &&
              (each.personalize_tag ===
                DEFAULT_CUSTOM_FIELD.INSURANCE_COMPANY ||
                each.personalize_tag === DEFAULT_CUSTOM_FIELD.POLICY_TYPE)
            ) {
              return (
                <div key={index} style={{ width: "100%", marginTop: "16px" }}>
                    <BasicFormControlWithLabelV2
                        label={each?.title}
                        fullWidth
                        options={
                            each.personalize_tag ===
                            DEFAULT_CUSTOM_FIELD.INSURANCE_COMPANY
                                ? insuranceCompanyOptions
                                : PolicyOptions
                        }
                        mapping={{
                            label:
                                each.personalize_tag ===
                                DEFAULT_CUSTOM_FIELD.INSURANCE_COMPANY
                                    ? "company_name"
                                    : "title",
                            value:
                                each.personalize_tag ===
                                DEFAULT_CUSTOM_FIELD.INSURANCE_COMPANY
                                    ? "company_name"
                                    : "title",
                        }}
                        defaultText={
                            each.personalize_tag ===
                            DEFAULT_CUSTOM_FIELD.INSURANCE_COMPANY
                                ? "Select insurance company"
                                : "Select policy type"
                        }
                        placeholderText={
                            each.personalize_tag ===
                            DEFAULT_CUSTOM_FIELD.INSURANCE_COMPANY
                                ? "Search for insurance company..."
                                : "Search for policy type..."
                        }
                        onChange={(e) => handleSelectChange(e, each, index)}
                        value={
                            each.personalize_tag ===
                            DEFAULT_CUSTOM_FIELD.INSURANCE_COMPANY
                                ? selectedInsuranceCompany
                                : selectedPolicy
                        }
                        component={BasicSelectWithSearch}
                        sx={{
                            '& .MuiInputBase-root': {
                                marginTop: 0,
                            },
                            '& .MuiInputBase-input': {
                                border: 'none !important'
                            }
                        }}
                    />
                </div>
              );
            } else {
              return renderEachCustomField(
                each,
                index,
                handleCustomFieldChange,
                customFieldsData
              );
            }
          })}
      </Box>
     </div> 
    )}

      <Grid item xs={12}>
        <BasicInput
          name="comments"
          fullWidth
          placeholder="Comments"
          multiline
          rows={8}
          inputProps={{
            style: {
              minHeight: "150px",
            },
          }}
          onChange={(e) =>
            setContactForm((prev) => ({ ...prev, note: e.target.value }))
          }
          value={contactForm.note || ""}
        />
      </Grid>
    </Grid>
  );
};

export default ContactAdditionalInfoTab;
